import { Type } from '@angular/core';
import { DecisionNode } from '../../../core/models/decision-tree.model';

/**
 * Contract every node renderer fulfils. Inputs are passed via component
 * outlet; renderers reach the wizard store directly with `inject()` and call
 * its command API to advance the flow.
 */
export interface NodeRendererInputs {
  node: DecisionNode;
  /** Trade-local key used by the engine for traversal (parent → option.next). */
  nodeKey: string;
}

/**
 * Registry mapping node-type → component class. Adding a new node type means
 * registering one entry here; the engine itself stays untouched.
 */
export class NodeRendererRegistry {
  private readonly map = new Map<string, Type<NodeRendererInputs>>();

  register(type: string, component: Type<NodeRendererInputs>): void {
    this.map.set(type, component);
  }

  resolve(type: string): Type<NodeRendererInputs> | null {
    return this.map.get(type) ?? null;
  }
}
